import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { SafeArea } from 'capacitor-plugin-safe-area'

const ANDROID_EDGE_TO_EDGE_SDK_VERSION = 35
const SAFE_AREA_PLUGIN_NAME = 'SafeArea'
const SAFE_AREA_CHANGED_EVENT = 'safeAreaChanged'

const FALLBACK_INSETS = {
  top: 'max(env(safe-area-inset-top), 24px)',
  bottom: 'max(env(safe-area-inset-bottom), 24px)'
}

export async function syncAndroidSafeAreaInsets() {
  if (!(await isEdgeToEdgeAndroid())) return

  if (!Capacitor.isPluginAvailable(SAFE_AREA_PLUGIN_NAME)) {
    applySafeAreaInsets(FALLBACK_INSETS)
    return
  }

  const { insets } = await SafeArea.getSafeAreaInsets()
  applySafeAreaInsets(toPixels(insets))

  await SafeArea.addListener(SAFE_AREA_CHANGED_EVENT, (data) => applySafeAreaInsets(toPixels(data.insets)))
}

async function isEdgeToEdgeAndroid() {
  const { androidSDKVersion } = await Device.getInfo()

  return androidSDKVersion >= ANDROID_EDGE_TO_EDGE_SDK_VERSION
}

function toPixels(insets) {
  return Object.fromEntries(
    Object.entries(insets).map(([side, value]) => [side, `${value}px`])
  )
}

function applySafeAreaInsets(insets) {
  Object.entries(insets).forEach(([side, value]) => {
    document.documentElement.style.setProperty(`--safe-area-inset-${side}`, value)
  })
}
